module.exports = __webpack_public_path__ + "static/assets/f65721bab1e43d46213ea45b99f46de8.svg";